import styled from 'styled-components';


export const CommomContainer = styled.div.attrs({
})`
    position: relative;
    padding: 0px 0 0;

    background: var(--primary-color);
`;

// Seção de fundo escuro que envolve o FAQ
export const FAQSection = styled.section`
  width: 100%;
  background: var(--black-color);
  padding: 0;
`;

// Container principal para a seção de Perguntas Frequentes
export const FAQContainer = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
  padding: 60px 20px;
`;

// Título da seção de Perguntas Frequentes
export const FAQTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 40px;
  color: var(--white-color);
  text-wrap: balance;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 28px;
  }

  @media (max-width: 480px) {
    font-size: 1.3rem;
  }
`;

// Estilo para cada pergunta
export const Question = styled.div`
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 153, 0, 0.2);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  transition: background 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: rgba(255, 153, 0, 0.1);
    border-color: rgba(255, 153, 0, 0.5);
  }

  &:focus-visible {
    outline: 2px solid #FF9900;
    outline-offset: 2px;
  }
`;

// Texto da pergunta
export const QuestionText = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  color: var(--white-color);
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.95rem;
  }
`;

// Estilo da resposta (que será revelada ao clicar)
export const Answer = styled.div`
  padding: 16px 20px;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.72);
  background: rgba(255, 153, 0, 0.06);
  border-left: 3px solid var(--primary-color);
  border-radius: 0 0 12px 12px;
  margin-top: -10px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 0.92rem;
  }

  @media (max-width: 480px) {
    font-size: 0.88rem;
  }
`;
